import React from 'react';
import { cn } from '@/utils/cn';
import { formatDate } from '@/utils/projectUi';
import type { MemberDetail } from '../types/memberDetail.types';

interface MemberAccessBlockProps {
  member: MemberDetail;
  isLoading?: boolean;
}

export function MemberAccessBlock({ member, isLoading }: MemberAccessBlockProps) {
  if (isLoading) {
    return (
      <div className="animate-pulse rounded-md border border-slate-100 bg-white p-3 shadow-sm space-y-2">
        <div className="h-4 w-32 rounded bg-slate-50" />
        <div className="space-y-2">
          <div className="h-10 rounded bg-slate-50" />
          <div className="h-10 rounded bg-slate-50" />
          <div className="h-20 rounded bg-slate-50" />
        </div>
      </div>
    );
  }

  return (
    <div className="rounded-md border border-slate-100 bg-white p-3 shadow-sm space-y-2">
      <h2 className="text-sm font-medium text-slate-900 flex items-center gap-2">
        <i className="ri-shield-keyhole-line text-emerald-600" />
        Phân quyền & Truy cập
      </h2>

      <div className="space-y-3">
        <div className="flex items-center justify-between py-2 border-b border-slate-50 text-xs">
          <span className="font-medium text-slate-500">Phòng ban</span>
          <span className="font-medium text-slate-700">{member.department || 'Văn phòng'}</span>
        </div>
        <div className="flex items-center justify-between py-2 border-b border-slate-50 text-xs">
          <span className="font-medium text-slate-500">Ngày gia nhập</span>
          <span className="font-medium text-slate-700">{formatDate(member.joinDate)}</span>
        </div>
        <div className="flex flex-col gap-2 py-2">
          <span className="text-xs font-medium text-slate-500">Quyền hạn hệ thống</span>
          <div className="flex flex-wrap gap-2">
            {(member.permissions || []).map((perm) => (
              <span key={perm} className="rounded-md bg-slate-100 px-2 py-1 text-xs font-medium text-slate-600">
                {perm}
              </span>
            ))}
            {(!member.permissions || member.permissions.length === 0) && (
              <span className="text-xs italic text-slate-400">Chưa có quyền hạn cụ thể</span>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
